import { jsx as i } from "react/jsx-runtime";
import l, { useContext as c, useEffect as C, useRef as x } from "react";
function h({ children: e, data: r, displayedKeys: u = [] }) {
  const t = x({});
  function p(o, n) {
    t.current[o] = n;
  }
  function f(o) {
    delete t.current[o];
  }
  function d(o) {
    Object.keys(t.current).forEach((n) => {
      const m = o[n];
      t.current[n](m);
    });
  }
  return /* @__PURE__ */ i(
    s.Provider,
    {
      value: {
        dispatchAutoComplete: d,
        registerUpdate: p,
        unregisterUpdate: f
      },
      children: /* @__PURE__ */ i(
        a.Provider,
        {
          value: {
            data: r,
            displayedKeys: u
          },
          children: e
        }
      )
    }
  );
}
const a = l.createContext({
  data: null,
  displayedKeys: null
}), s = l.createContext({
  dispatchAutoComplete: () => {
  },
  registerUpdate: () => {
  },
  unregisterUpdate: () => {
  }
});
function v(e, r) {
  const { registerUpdate: u, unregisterUpdate: t } = c(s);
  return C(() => {
    if (!(e == null || r == null))
      return u(e, r), () => t(e);
  }, [e, r]), c(a);
}
function U() {
  return c(s);
}
export {
  h as default,
  v as useFormAutoComplete,
  U as useFormAutoCompleteDispatch
};
